var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAddIconDragger = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 1.8335C5.94884 1.8335 1.83301 5.94933 1.83301 11.0002C1.83301 16.051 5.94884 20.1668 10.9997 20.1668C16.0505 20.1668 20.1663 16.051 20.1663 11.0002C20.1663 5.94933 16.0505 1.8335 10.9997 1.8335ZM14.6663 11.6877H11.6872V14.6668C11.6872 15.0427 11.3755 15.3543 10.9997 15.3543C10.6238 15.3543 10.3122 15.0427 10.3122 14.6668V11.6877H7.33301C6.95717 11.6877 6.64551 11.376 6.64551 11.0002C6.64551 10.6243 6.95717 10.3127 7.33301 10.3127H10.3122V7.3335C10.3122 6.95766 10.6238 6.646 10.9997 6.646C11.3755 6.646 11.6872 6.95766 11.6872 7.3335V10.3127H14.6663C15.0422 10.3127 15.3538 10.6243 15.3538 11.0002C15.3538 11.376 15.0422 11.6877 14.6663 11.6877Z",
    fill: "#807EEC"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddIconDragger, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/AddIconDragger.1a90783d.svg";
export { ForwardRef as ReactComponent };